import React from "react";
import styled from "styled-components";

const Body = styled.div`
  display: flex;
  align-items: center;
`;

const CircleStyled = styled.div`
  border-radius: 50%;
  background: #f1585e;
  width: 11px;
  height: 11px;
`;

const TextStyled = styled.div`
  fontsize: 14px;
  color: #575757;
`;

export const PaymentStatus = ({ type }) => {
  switch (type) {
    case "Paid":
      return (
        <Body>
          <CircleStyled style={{ background: "#4CAF50" }} className="mx-3" />
          <TextStyled>{type}</TextStyled>
        </Body>
      );

    default:
      return (
        <Body>
          <CircleStyled className="mx-3" />
          <TextStyled>{type}</TextStyled>
        </Body>
      );
  }
};
